import { Link } from "react-router-dom";

const SITE_LINKS = [
  { to: "/movie", label: "电影频道" },
  { to: "/tv", label: "电视剧频道" },
  { to: "/search", label: "影视搜索" },
  { to: "/about", label: "关于我们" },
];

const FRIEND_LINKS = ["光影社区", "独立影评", "影像档案馆", "银幕手记"];

export default function Footer() {
  return (
    <footer className="bg-primary-950 border-t border-primary-900">
      <div className="mx-auto grid w-full grid-cols-1 gap-8 px-4 py-10 md:grid-cols-2 md:px-8 md:py-14 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-950">
              <i className="ri-movie-2-fill text-xl"></i>
            </span>
            <span className="font-heading text-lg font-bold text-foreground-50">免费播放片大片</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-300">
            汇聚最新最全的电影与电视剧资源，覆盖动作、喜剧、科幻、悬疑等多种类型，为影视爱好者提供免费、高清、分类清晰的在线影视内容浏览体验。
          </p>
          <div className="mt-4 flex items-center gap-3 text-sm text-foreground-300">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-900 text-accent-400">
              <i className="ri-mail-line"></i>
            </span>
            <span>联系我们：support@fpfp-demo.example</span>
          </div>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-foreground-50">
            <Link to="/movie">站点导航</Link>
          </h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            {SITE_LINKS.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="text-foreground-300 transition-colors hover:text-accent-400">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-foreground-50">
            <Link to="/about">友情链接</Link>
          </h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            {FRIEND_LINKS.map((label) => (
              <li key={label}>
                <a
                  href="https://readdy.ai"
                  target="_blank"
                  rel="nofollow noopener"
                  className="text-foreground-300 transition-colors hover:text-accent-400"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-900">
        <div className="mx-auto flex w-full flex-col gap-2 px-4 py-5 text-xs text-foreground-400 sm:flex-row sm:items-center sm:justify-between md:px-8">
          <p>© 2026 免费播放片大片 · 本站影视信息均为虚构示例数据，仅供演示学习使用。</p>
          <p>本站不提供真实在线播放服务，所有内容不构成任何观看与传播建议。</p>
        </div>
      </div>
    </footer>
  );
}